import Select from 'react-select'

interface Props{
    title?:string;
    type:'text'|'number'|'select';
    label: string;
    onChange?:(val?:any) => void;
    options?:{value:string;label:string}[];
}

const FormGenerator:React.FC<Props> = ({title,type, label, onChange, options}) => {
    const renderInput = () => (
        <input 
            type={type}
            onChange={(val)=>{
                    if(onChange)onChange(val.currentTarget.value);
                }
            }
            className='border border-gray-100 w-full h-[42px] rounded-md px-3'
        />
    );

    const renderSelect = () => (
        <Select 
            options={options} 
            onChange={(val)=>{
                if(onChange)onChange(val?.value);
            }
        }
        />
    )
    return (
        <div className='w-full flex flex-col items-start justify-center'>
            <p className={`font-semibold text-[24px] mb-10 md:text-[32px]`}>{title}</p>
            <div className='w-full'>
                <p className='opacity-[0.5]'>{label}</p>
                {type === 'select'? renderSelect():renderInput()}
            </div>
        </div>
    )

}

export default FormGenerator;